import { useMediaQuery as useMuiMediaQuery } from '@mui/material';

import type { Breakpoint, Breakpoints, Theme } from '@mui/material';

type MuiDirection = Pick<Breakpoints, 'up' | 'down'>;
type Direction = keyof MuiDirection | undefined;

export const useMediaQuery = (
  breakpoint: Breakpoint,
  direction: Direction = 'up',
) =>
  useMuiMediaQuery((theme: Theme) => theme.breakpoints[direction](breakpoint));
